import React from "react";
import { useTranslation } from "react-i18next";
import PageWrapper from "../../../../components/common/layout/PageWrapper";
import { CardSpg } from "@duosoftbg/nacid-components";
import { CardContent } from "@mui/material";
import Cache from "../../../../components/admin/cache/Cache";

const CachePage = () => {
  const { t } = useTranslation();

  return (
    <PageWrapper title={t("t.page.cache")}>
      <CardSpg my={4} style={{ overflow: "visible", marginLeft: "auto", marginRight: "auto" }}>
        <CardContent style={{ padding: 24, position: "relative" }}>
          <Cache />
        </CardContent>
      </CardSpg>
    </PageWrapper>
  );
};

export default CachePage;
